module.exports = __webpack_public_path__ + "static/media/social-bakers.6001ff91.png";